import React, { useState, useEffect, useContext } from "react";
import Header from "./Header";
import DotsLog from "../img/DotsLog.svg";
import RightArow from "../img/RightArow.svg";
import Close_round from "../img/Close_round.svg";
import CoupenSuccesGif from "../img/CoupenSuccesGif.gif";
import GifCoupon from "../img/GifCoupon.gif";
import api from "../../api/axiosInstance";
import editIcon from "../img/Edit_fill.svg";
import deleteIcon from "../img/deleteicon.svg";
import User from "../img/User.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CompanyIcon from "../img/CompanyIcon.svg";
import AppFooter from "./AppFooter";
import { CartContext } from "../../context/CartContext";
import Close_roundClose from "../img/Close_roundClose.svg";

const Cart = () => {
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [calculations, setCalculations] = useState(null);
  const { cartCount, fetchCartCount } = useContext(CartContext);
  const [showFullLoader, setShowFullLoader] = useState(false);
  const [isVerifyingPayment, setIsVerifyingPayment] = useState(false);
  // State to handle modal visibility
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPaymentVerified, setIsPaymentVerified] = useState(false);
  const [isFromKerala, setIsFromKerala] = useState(false);

  const [profile, setProfile] = useState({});
  const [razorpaydata, setRazorPayData] = useState({});
  const [tdsDeducted, setTdsDeducted] = useState(false);
  const [tdsAmount, setTdsAmount] = useState(0); // Optional if calculations includes it
  const [paymentDomain, setPaymentDomain] = useState("");

  // address data
  const [addresses, setAddresses] = useState([]);
  const [defaultAddress, setDefaultAddress] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [paymentSuccessModalOpen, setPaymentSuccessModalOpen] = useState(false);

  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false); // Modal state for "Add a new address"
  const [userCountry, setUserCountry] = useState("");
  const [userCountryCode, setUserCountryCode] = useState("");

  const [showModal, setShowModal] = useState(false);

  const [postalCode, setPostalCode] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [gstNo, setGstNo] = useState("");
  const [address, setAddress] = useState("");
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showPostalModal, setShowPostalModal] = useState(false);
  const [latitude, setLatitude] = useState(""); // Latitude input
  const [longitude, setLongitude] = useState(""); // Longitude input
  const [licenseNumber, setLicenseNumber] = useState(""); // License Number
  const [isTdsDeducted, setIsTdsDeducted] = useState(false);

  const [domainModalOpen, setDomainModalOpen] = useState(false);
  const [duplicateDomainInfo, setDuplicateDomainInfo] = useState({
    organization_name: "",
    domain: "",
  });

  const [genericErrorModalOpen, setGenericErrorModalOpen] = useState(false);
  const [genericErrorMessage, setGenericErrorMessage] = useState("");

  const [editedDomain, setEditedDomain] = useState("");

  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorModalMessage, setErrorModalMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [loadingItem, setLoadingItem] = useState(null);

  //coupon details

  const [couponInputs, setCouponInputs] = useState({});
  const [appliedCoupons, setAppliedCoupons] = useState([]);
  const [appliedItemIds, setAppliedItemIds] = useState([]);

  //Displaying Error
  const [errors, setErrors] = useState({});

  // When opening the modal, set the editable domain
  useEffect(() => {
    if (duplicateDomainInfo?.domain) {
      setEditedDomain(duplicateDomainInfo.domain);
    }
  }, [duplicateDomainInfo]);

  // Handle location selection
  const handleLocationSelection = (location) => {
    setSelectedLocation(location); // Update selected location with the details
  };

  const handleConfirmLocation = () => {
    if (selectedLocation) {
      // If we're editing an address
      if (isEditModalOpen && selectedAddress) {
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the edit address modal
        setShowPostalModal(false);
        setIsEditModalOpen(true); // Open the edit modal
      } else {
        // If we're adding a new address
        setCity(selectedLocation.postalLocation); // Use postal location for city
        setDistrict(selectedLocation.district); // Use selected district
        setState(selectedLocation.state); // Use selected state
        setCountry(selectedLocation.country); // Use selected country
        setPostalCode(selectedLocation.postalCode); // Use postal code

        // Close the postal location modal and open the add address modal
        setShowPostalModal(false);
        setIsAddressModalOpen(true); // Open the add address modal
      }
    }
  };

  // Handle confirm location, populate address modal with selected data
  const handleEditConfirmLocation = () => {
    if (selectedLocation) {
      setCity(selectedLocation.postalLocation);
      setDistrict(selectedLocation.district);
      setState(selectedLocation.state);
      setCountry(selectedLocation.country);
      setPostalCode(selectedLocation.postalCode);
      setShowPostalModal(false); // Close the postal location modal
      setIsEditModalOpen(true); // Open the address modal
    }
  };

  // Function to toggle modal visibility
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Open the modal and fetch the addresses
  useEffect(() => {
    if (isModalOpen) {
      fetchAddresses();
    }
  }, [isModalOpen]);

  // Fetch addresses from the API
  const fetchAddresses = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }
    try {
      const response = await api.get("/display/api/v1/list-billing-address", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        // Add any authorization token if required
      });

      // No need to call response.json() with Axios, the data is already parsed
      const data = response.data;

      if (data.status === "success") {
        setAddresses(data.data);

        // Set the default address if available
        const defaultAddr = data.data.find((address) => address.is_default);
        setDefaultAddress(defaultAddr);
        console.log("default address", defaultAddr);
      } else {
        console.error("Error fetching addresses", data.response_code);
      }
    } catch (error) {
      console.error("Error fetching addresses", error);
    }
  };

  useEffect(() => {
    fetchCartData();
  }, []);

  // user data
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    api
      .get("/display/api/v1/read-update-profile", {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        if (res.data.status === "success") {
          const fetchedProfile = res.data.data;
          setProfile(fetchedProfile);
        }
      })
      .catch((err) => {
        console.error("Error fetching profile:", err);
      });
  }, []);

  const fetchCartData = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const response = await api.get("/display/api/v1/list-cart", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.data?.status === "success") {
        setCartItems(response.data.data.cart_data || []);
        setCalculations(response.data.data.calculations || {});
      } else {
        console.warn("Failed to fetch cart data.");
        // Optional: set error state if needed
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
      alert("Something went wrong.");
    }
  };

  const toggleDropdown = () => setShowDropdown((prev) => !prev);
  const handleShare = () => {
    setShowDropdown(false);
  };

  const handleInvoice = () => {
    setShowDropdown(false);
  };

  const handleDeleteCartItem = async (id) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const response = await api.delete(`/display/api/v1/delete-cart/${id}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.data?.status === "success") {
        // Update state immediately for fast UI
        setCartItems((prev) => prev.filter((item) => item.id !== id));
        fetchCartCount();

        // Refresh cart data in background to sync calculations etc.
        await fetchCartData();
      } else {
        alert("Failed to remove item from cart.");
      }
    } catch (error) {
      console.error("Error deleting cart item:", error);
      alert("Something went wrong while removing the item.");
    }
  };

  const handleRemoveAllCartItems = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const response = await api.delete("/display/api/v1/remove-all-cart", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      console.log("Remove All Response:", response.data);

      if (response.data?.status === "success") {
        setCartItems([]);
        setCalculations(null);
        fetchCartCount();
      } else {
        alert("Failed to remove all items from cart.");
      }
    } catch (error) {
      console.error(
        "Error removing all cart items:",
        error.response || error.message || error
      );
      alert("Something went wrong while clearing the cart.");
    }
  };

  const handleDeleteTopup = async (topupId) => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const response = await api.delete(
        `/display/api/v1/delete-cart/${topupId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data?.status === "success") {
        fetchCartData(); // Refresh the cart
      } else {
        alert("Failed to remove add-on.");
      }
    } catch (error) {
      console.error("Error deleting add-on:", error.response || error);
      alert("Something went wrong while removing the add-on.");
    }
  };

  const toggleAddressModal = () => {
    setAddress("");
    setPostalCode("");
    setCity("");
    setDistrict("");
    setState("");
    setCountry("");
    setGstNo("");
    setLatitude("");
    setLongitude("");
    setErrors({});

    setIsAddressModalOpen(!isAddressModalOpen);
  };

  // Toggle Edit Modal
  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };

  // Open Edit Modal with selected address data
  const handleUpdate = (index) => {
    const addressToEdit = addresses[index];
    setSelectedAddress(addressToEdit);
    setAddress(addressToEdit.address_1);
    setPostalCode(addressToEdit.pincode);
    setCity(addressToEdit.city);
    setDistrict(addressToEdit.district);
    setState(addressToEdit.state);
    setCountry(addressToEdit.country);
    setGstNo(addressToEdit.gstNo);
    setIsEditModalOpen(true); // Open Edit Modal
  };

  // Function to handle the postal code change
  const handlePostalCodeChange = async (e) => {
    const enteredPostalCode = e.target.value;
    setPostalCode(enteredPostalCode);

    // Only call API when exactly 6 digits
    if (!enteredPostalCode || enteredPostalCode.length !== 6) {
      setShowPostalModal(false);
      setLocations([]);
      setSelectedLocation(null);
      return;
    }

    try {
      const res = await axios.get(
        `https://api.postalpincode.in/pincode/${enteredPostalCode}`
      );

      const first = Array.isArray(res.data) ? res.data[0] : null;

      if (first?.Status === "Success" && Array.isArray(first?.PostOffice)) {
        // ✅ normalize response to match your existing UI structure
        const normalized = first.PostOffice.map((po, idx) => ({
          id: `${enteredPostalCode}-${idx}`,
          postalLocation: po.Name, // used in modal label + used as "city" in confirm handler
          district: po.District,
          state: po.State,
          country: po.Country,
          postalCode: enteredPostalCode,
        }));

        const foundKerala = normalized.some(
          (loc) => (loc.state || "").toLowerCase() === "kerala"
        );

        setIsFromKerala(foundKerala);
        setLocations(normalized);
        setShowPostalModal(true);
      } else {
        // No records found / error
        setShowPostalModal(false);
        setLocations([]);
        setSelectedLocation(null);
        console.warn(first?.Message || "No records found");
      }
    } catch (error) {
      console.error("Error fetching postal data:", error);
      setShowPostalModal(false);
      setLocations([]);
      setSelectedLocation(null);
    }
  };

  // Function to close the modal
  const handleModalClose = () => {
    setShowPostalModal(false);
  };

  const handleSaveAddress = async () => {
    // validate
    const newErrors = {};
    if (!address.trim()) newErrors.address = "Enter your street.";
    if (!postalCode.trim()) {
      newErrors.postalCode = " Enter your postal code.";
    }
    if (!city.trim()) newErrors.city = "Enter your city.";
    if (!district.trim()) newErrors.district = "Enter your district.";
    if (!state.trim()) newErrors.state = "Enter your state.";
    if (!country.trim()) newErrors.country = "Enter your country.";
    // GST optional

    setErrors(newErrors);

    // if there are any errors, do not proceed
    if (Object.keys(newErrors).length > 0) {
      return;
    }

    // proceed with API call
    console.log("Save clicked with data:", {
      address_1: address,
      city,
      state,
      pincode: postalCode,
      latitude: latitude || 0,
      longitude: longitude || 0,
      district,
      country,
      license_number: gstNo || "",
      is_from_kerala: isFromKerala,
    });

    try {
      const res = await api.post(
        "/display/api/v1/create-billing-address",
        {
          address_1: address,
          city,
          state,
          pincode: postalCode,
          latitude: latitude || 0,
          longitude: longitude || 0,
          district,
          country,
          license_number: gstNo || "",
          is_from_kerala: isFromKerala,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Billing address created:", res.data);
      fetchAddresses();

      // clear form
      setAddress("");
      setCity("");
      setCountry("");
      setDistrict("");
      setGstNo("");
      setPostalCode("");
      setState("");

      setIsAddressModalOpen(false);
    } catch (err) {
      console.error("Error creating billing address:", err.response || err);
    }
  };

  // Handle editing an address
  const handleEditAddress = async () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }

    try {
      const updatedAddress = {
        address_1: address,
        pincode: postalCode,
        city,
        district,
        state,
        country,
        gstNo,
      };

      // Make PATCH request to the server
      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${selectedAddress.id}`,
        updatedAddress,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        // On successful update, update the address list
        const updatedAddresses = addresses.map((addr) =>
          addr.id === selectedAddress.id ? { ...addr, ...updatedAddress } : addr
        );
        setAddresses(updatedAddresses);
        toggleEditModal(); // Close the modal
      } else {
        console.error("Failed to update address");
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedAddressId, setSelectedAddressId] = useState(null);

  const [isMessageModalOpen, setMessageModalOpen] = useState(false); // Single modal visibility
  const [message, setMessage] = useState(""); // Store the message
  const [messageType, setMessageType] = useState(""); // Store the type (success or error)

  // Toggle the Delete Confirmation Modal
  const toggleDeleteModal = (id = null) => {
    setSelectedAddressId(id);
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const handleDeleteAccount = async () => {
    // Retrieve the access token from session storage
    const accessToken = localStorage.getItem("accessToken");

    // Check if access token exists; if not, prompt the user to log in
    if (!accessToken) {
      alert("Please log in first.");
      return;
    }
    // Prevent deleting the default address
    if (selectedAddressId === defaultAddress?.id) {
      setMessage("Default billing address cannot be deleted.");
      setMessageType("error");
      setMessageModalOpen(true);
      return;
    }

    try {
      // Make a DELETE request to the backend API to delete the address
      const response = await api.delete(
        `/display/api/v1/patch-delete-billing-address/${selectedAddressId}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`, // Add Authorization header with access token
          },
        }
      );

      // If the response status is 200, it means the delete operation was successful
      if (response.status === 200) {
        fetchAddresses();
        // Filter the addresses list to remove the deleted address
        setAddresses(
          addresses.filter((address) => address.id !== selectedAddressId)
        );
        // Set the success message
        setMessage("Address successfully deleted!");
        // Set the message type as success
        setMessageType("success");
        // Open the success modal
        setMessageModalOpen(true);
      } else {
        // If the status is not 200, set the error message
        setMessage("Failed to delete the address. Please try again.");
        // Set the message type as error
        setMessageType("error");
        // Open the error modal
        setMessageModalOpen(true);
      }
    } catch (error) {
      // Handle any errors that occur during the delete request
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        // If the error response contains a message, display it
        setMessage(`Error: ${error.response.data.message}`);
      } else {
        // If no error message is returned, display a generic error message
        setMessage("An error occurred. Please try again.");
      }
      // Set the message type as error
      setMessageType("error");
      // Open the error modal
      setMessageModalOpen(true);
    }
  };

  // Toggle the modal
  const toggleMessageModal = () => {
    setMessageModalOpen(!isMessageModalOpen);
    setIsDeleteModalOpen(!isDeleteModalOpen);
    setMessage(""); // Reset message when modal is toggled
  };

  const handleSetDefaultAddress = async (id) => {
    try {
      const token = localStorage.getItem("accessToken"); // Get the token from session storage

      if (!token) {
        console.error("No token found");
        return;
      }

      // Send PATCH request to update the address to default
      const response = await api.patch(
        `/display/api/v1/patch-delete-billing-address/${id}`,
        {
          is_default: true,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
        // On successful response, update the address state
        const updatedAddresses = addresses.map(
          (address) =>
            address.id === id
              ? { ...address, is_default: true } // Update the clicked address to default
              : { ...address, is_default: false } // Set the rest to non-default
        );
        setAddresses(updatedAddresses);
        fetchAddresses();
      } else {
        console.error("Failed to update address:", response.data);
      }
    } catch (error) {
      console.error("Error updating address:", error);
    }
  };

  const handleTdsToggle = () => {
    const { total_price, tds_percentage } = calculations;
    const tdsAmountCalculated = (total_price * tds_percentage) / 100;

    setTdsDeducted((prev) => !prev);
    setTdsAmount(tdsAmountCalculated);

    // Set "is_tds_deducted" to true after the deduction
    if (!isTdsDeducted) {
      setIsTdsDeducted(true); // Mark that TDS has been deducted
    } else {
      setIsTdsDeducted(false); // Reset if needed when toggling off
    }
  };

  const handleProceed = () => {
    const token = localStorage.getItem("accessToken");

    if (!token) {
      alert("Please log in first.");
      return;
    }

    setIsLoading(true); // Start loading

    // Prepare payload data early (without amount for Razorpay)
    const roundedTotalAmount = (() => {
      const totalAmount = tdsDeducted
        ? calculations.grant_total - tdsAmount
        : calculations.grant_total;
      return totalAmount.toFixed(2);
    })();

    const data = {
      address_id: defaultAddress.id,
      is_tds_deducted: tdsDeducted,
      total_amount: roundedTotalAmount,
      coupon_details: appliedCoupons,
    };

    api
      .post("/display/api/v1/initiate-purchase", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          const fetchRazorpayData = res.data.data;
          setRazorPayData(fetchRazorpayData);
          const purchaseId = fetchRazorpayData.purchase_id;

          if (!fetchRazorpayData.razorpay_code) {
            setIsVerifyingPayment(true);
            // Call verify API directly with empty payment details
            verifyPayment("", "", "", purchaseId);
            return;
          }

          // Recalculate amountInPaise here, right before opening Razorpay
          const totalAmountForPayment = tdsDeducted
            ? calculations.grant_total - tdsAmount
            : calculations.grant_total;
          const roundedAmountForPayment = totalAmountForPayment.toFixed(2);
          const amountInPaise = Math.round(roundedAmountForPayment * 100);

          const options = {
            key: fetchRazorpayData.razorpay_key,
            amount: amountInPaise, // Use fresh calculated amount here
            order_id: fetchRazorpayData.razorpay_code,
            currency: "INR",
            name: "MGC Group",
            description: "Test Transaction",
            image: "https://your-logo-url.com",
            handler: function (response) {
              const {
                razorpay_payment_id,
                razorpay_order_id,
                razorpay_signature,
              } = response;

              verifyPayment(
                razorpay_order_id,
                razorpay_payment_id,
                razorpay_signature,
                purchaseId
              );
            },
            prefill: {
              name: profile.first_name,
              email: profile.email,
              contact: profile.phone_number,
            },
            notes: {
              address: "Razorpay Corporate Office",
            },
            theme: {
              color: "#8973EF",
            },
          };

          const razorpay = new window.Razorpay(options);
          razorpay.open();
        } else {
          const response = res?.data;

          if (response?.is_domain_duplicated) {
            setDuplicateDomainInfo({
              organization_name:
                response.data?.organization_name || "Unknown Org",
              domain: response.data?.domain || "unknown",
            });
            setDomainModalOpen(true);
          } else {
            setGenericErrorMessage(
              response?.message || "Something went wrong."
            );
            setGenericErrorModalOpen(true);
          }
        }
      })
      .catch((err) => {
        console.error("Unexpected error:", err);
        setGenericErrorMessage("Something went wrong. Please try again later.");
        setGenericErrorModalOpen(true);
      })
      .finally(() => {
        setIsLoading(false); // Stop loading
      });
  };

  // Verify Payment Function
  const verifyPayment = (
    razorpay_order_id,
    razorpay_payment_id,
    razorpay_signature,
    purchase_id
  ) => {
    const token = localStorage.getItem("accessToken");

    // Prepare data for the verify purchase API
    const verifyData = {
      razorpay_order_id,
      razorpay_payment_id,
      razorpay_signature,
      purchase_id,
    };

    setIsVerifyingPayment(true);

    // Call the verify purchase API
    api
      .post("/display/api/v1/verify-purchase", verifyData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          // navigate("/MyProducts");
          setPaymentSuccessModalOpen(true);
          setPaymentDomain(res.data.data.domain);
          setIsPaymentVerified(true);

          //alert("Payment Verified Successfully!");
          // Handle successful payment verification (e.g., save data, redirect, etc.)
        } else {
          alert("Payment Verification Failed");
          console.error("Verification Failed:", res.data);
          setIsPaymentVerified(false);
        }
      })
      .catch((err) => {
        console.error("Error verifying payment:", err);
        // alert("Error occurred during payment verification");
        setIsPaymentVerified(false);
      })
      .finally(() => {
        setIsVerifyingPayment(false); // ✅ hide loader
      });
  };

  const handleDomainEditAndProceed = async () => {
    if (!editedDomain) {
      setErrorModalMessage("Please enter a valid domain.");
      setErrorModalOpen(true);
      return;
    }

    try {
      const token = localStorage.getItem("accessToken");
      const response = await api.post(
        "/display/api/v1/update-domain",
        { domain: editedDomain },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.status === "success") {
        setDomainModalOpen(false);
        navigate("/cart");
      } else {
        setErrorModalMessage(response.data.message || "Domain update failed.");
        setErrorModalOpen(true);
      }
    } catch (err) {
      console.error("Domain update error:", err);
      setErrorModalMessage(
        err.response?.data?.message ||
          "Something went wrong while updating the domain."
      );
      setErrorModalOpen(true);
    }
  };

  // Helper to check if coupon applied for this cart item
  const isCouponApplied = (itemId) => {
    return appliedCoupons.some((coupon) => coupon.cart_id === itemId);
  };

  const handleApplyCoupon = async (item) => {
    const rawCode = couponInputs[item.id];
    const couponCode = couponInputs[item.id];

    if (!couponCode) {
      setErrorModalMessage("Please enter a coupon code.");
      setErrorModalOpen(true);
      return;
    }

    const availableCoupons = Array.isArray(item.coupon_data)
      ? item.coupon_data
      : [];

    const matchedCoupon = availableCoupons.find((c) =>
      (c.coupon_codes || [])
        .map((code) => code.toUpperCase())
        .includes(couponCode)
    );

    if (!matchedCoupon) {
      // Code does not exist in coupon_data → show error, do NOT call API
      setErrorModalMessage("This coupon code is not valid for this product.");
      setErrorModalOpen(true);
      return;
    }

    const newCouponData = {
      coupon_id: matchedCoupon.id, // 👈 from the matched coupon
      cart_id: item.id,
      coupon_code: couponCode, // the exact code the user entered
    };

    const updatedCoupons = [...appliedCoupons, newCouponData];

    try {
      // Set the loading state for this item
      // setLoadingItem(item.id);

      // Apply the coupon
      const token = localStorage.getItem("accessToken");
      const response = await api.post(
        "/display/api/v1/apply-coupon",
        updatedCoupons,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.status === "success") {
        setLoadingItem(item.id); // Set the item ID to indicate loading
        console.log("Coupons applied:", updatedCoupons);
        setAppliedCoupons(updatedCoupons);
        setAppliedItemIds((prev) => [...prev, item.id]);

        if (response.data.data) {
          setCalculations({
            total_price: response.data.data.calculations.total_price,
            grant_total: response.data.data.calculations.grant_total,
            percentage_value: response.data.data.calculations.percentage_value,
            tds_percentage: response.data.data.calculations.tds_percentage,
            total_offer: response.data.data.calculations.total_offer,
            tax_configurations:
              response.data.data.calculations.tax_configurations || [],
          });
        }

        if (response.data.data?.coupon_data?.length > 0) {
          // Save original values before applying coupon if not already saved
          const updatedCartItems = cartItems.map((cartItem) => {
            const matchedCoupon = response.data.data.coupon_data.find(
              (cd) => cd.cart_id === cartItem.id
            );

            if (matchedCoupon) {
              const duration = matchedCoupon.coupon_details.find(
                (cd) => cd.applying_type === "duration"
              )?.data?.[0]?.updated;

              const updatedPrice = matchedCoupon.coupon_details.find(
                (cd) => cd.applying_type === "price"
              )?.data?.[0]?.updated;

              const updatedLimits = matchedCoupon.coupon_details.find(
                (cd) => cd.applying_type === "limit"
              )?.data;

              // ✅ Save original values only once
              return {
                ...cartItem,
                original_validity:
                  cartItem.original_validity || cartItem.validity,
                original_price: cartItem.original_price || cartItem.total_price,
                original_limits_data:
                  cartItem.original_limits_data || cartItem.limits_data,
                validity: duration || cartItem.validity,
                total_price: updatedPrice || cartItem.total_price,
                limits_data:
                  updatedLimits && Array.isArray(updatedLimits)
                    ? updatedLimits.map((l) => ({
                        limit_name: l.based_on, // ✅ Preserve limit_name for display
                        count: l.updated,
                      }))
                    : cartItem.limits_data,
              };
            }

            return cartItem;
          });

          setCartItems(updatedCartItems);
        }

        // Show loader for 2 seconds and then reset
        setTimeout(() => {
          setLoadingItem(null); // Reset the loading state after 2 seconds
        }, 2000);

        // ✅ Only show loader after successful application
        setShowFullLoader(true);
        setTimeout(() => {
          setShowFullLoader(false);
        }, 2000);
      } else {
        const errorMsg = response.data.message || "Failed to apply coupon.";
        setLoadingItem(null); // ❗ Stop the per-item loader
        if (!errorMsg.toLowerCase().includes("invalid coupon")) {
          setErrorModalMessage(errorMsg);
          setErrorModalOpen(true);
        } else {
          console.warn("Invalid coupon code:", errorMsg);
        }
        return; // ❗ Exit early, avoid triggering full loader
      }
    } catch (err) {
      console.error(
        "Something went wrong while applying coupon.",
        err.response?.data?.message || err.message
      );
      setErrorModalMessage(
        err.response?.data?.message ||
          "Something went wrong while applying coupon."
      );
      setErrorModalOpen(true);

      // Reset the loading state if there's an error
      setLoadingItem(null);
    }
  };

  const handleRemoveCoupon = (itemId) => {
    // 1. Remove from appliedCoupons
    const updatedCoupons = appliedCoupons.filter(
      (coupon) => coupon.cart_id !== itemId
    );
    setAppliedCoupons(updatedCoupons);

    // 2. Remove from appliedItemIds
    setAppliedItemIds((prev) => prev.filter((id) => id !== itemId));

    // 3. Clear the coupon input field
    setCouponInputs((prevInputs) => ({
      ...prevInputs,
      [itemId]: "",
    }));

    // 4. Restore original values to the cart item
    const updatedCartItems = cartItems.map((item) => {
      if (item.id === itemId) {
        return {
          ...item,
          validity: item.original_validity || item.validity,
          total_price: item.original_price || item.total_price,
          limits_data: item.original_limits_data || item.limits_data,
        };
      }
      return item;
    });

    setCartItems(updatedCartItems);

    // 5. Recalculate the new total price and grant total
    const newTotal = updatedCartItems.reduce((acc, item) => {
      const topupTotal =
        item.topup_data?.reduce(
          (tpSum, tp) => tpSum + (tp.total_price || 0),
          0
        ) || 0;
      return acc + item.total_price + topupTotal;
    }, 0);

    // Recalculate tax using percentage from old calculations
    const taxPercent =
      calculations?.percentage_value && calculations?.total_price
        ? (calculations.percentage_value / calculations.total_price) * 100
        : 18;

    const updatedTax = (newTotal * taxPercent) / 100;

    setCalculations({
      ...calculations,
      total_price: newTotal,
      grant_total: newTotal + updatedTax,
      total_offer: 0,
      percentage_value: updatedTax,
    });

    // Reset TDS if previously applied
    setTdsDeducted(false);
    setIsTdsDeducted(false);
    setTdsAmount(0);

    console.log("Updated Cart Items:", updatedCartItems);
    console.log("New Total Price:", newTotal);
    console.log("Updated Tax:", updatedTax);
    console.log("Updated Calculations:", {
      total_price: newTotal,
      grant_total: newTotal + updatedTax,
    });
  };

  return (
    <div>
      <Header></Header>
      <div class="px-5 sm:px-10" style={{ backgroundColor: "#FFFFFF" }}>
        <div class="flex justify-between my-10 ">
          <h1 class="text-3xl font-semibold">Cart</h1>
          {cartItems.length > 0 && (
            <span
              className="px-4 h-8 flex text-sm items-center cursor-pointer rounded text-white font-semibold"
              style={{
                background: "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
              }}
              onClick={handleRemoveAllCartItems}
            >
              Remove All
            </span>
          )}
        </div>

        {cartItems.length > 0 ? (
          <>
            {/* <h1 className="text-lg mb-3">Apps that you are interested in.</h1> */}
            <div className="hidden sm:grid font-semibold grid-cols-6 gap-4 px-4 bg-[#CEC7FF4D] py-2 rounded-md font-medium text-base">
              <span>Application Name</span>
              <span className="pl-4">Plan</span>
              <span>Validity</span>
              <span>Limit</span>
              <span>Price</span>
              <span></span>
            </div>

            {cartItems.map((item, index) => (
              <div
                key={item.id}
                className="flex flex-col mt-4 border border-[#D9D9D9] rounded-lg p-4  relative"
                style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
              >
                {/* Main Grid Row */}
                <div className="grid grid-cols-1 sm:grid-cols-6 items-start w-full mt-3 gap-4">
                  {/* 1. Application License */}
                  <div className="flex gap-3 items-center">
                    <div className="h-14 w-14 bg-gray-300 rounded">
                      <img
                        src={item.app_icon}
                        alt=""
                        className="h-full w-full object-cover rounded"
                      />
                    </div>
                    <div className="flex flex-col">
                      <span className="text-sm font-medium text-gray-900">
                        {item.app_name}
                      </span>
                      <span className="text-xs text-gray-500">
                        {item.company_name}
                      </span>
                    </div>
                  </div>

                  {/* 2–6: Plan to Remove in aligned container */}
                  <div className="col-span-1 sm:col-span-5">
                    <div className="grid grid-cols-1 sm:grid-cols-5 gap-4 bg-[#F4F4FF] px-4 py-3 rounded-md ">
                      {/* Plan */}
                      <div className="flex justify-between">
                        <span className=" text-sm">{item.item_name}</span>

                        {/* Remove */}
                        <div className="flex justify-end sm:hidden">
                          <img
                            src={Close_round}
                            alt="remove"
                            className="h-5 w-5 cursor-pointer"
                            onClick={() => handleDeleteCartItem(item.id)}
                          />
                        </div>
                      </div>

                      {/* Validity */}
                      <div className="text-sm ">
                        {item.original_validity &&
                          item.original_validity !== item.validity && (
                            <span
                              className="text-gray-500 text-sm mr-1"
                              style={{
                                position: "relative",
                                color: "#4B5563", // Tailwind's text-gray-700
                                display: "inline-block",
                              }}
                            >
                              {item.original_validity}
                              <span
                                style={{
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: 0,
                                  right: 0,
                                  height: "1px",
                                  backgroundColor: "red",
                                  transform: "translateY(-50%)",
                                }}
                              />
                            </span>
                          )}
                        <span>{item.validity}</span>
                      </div>

                      {/* Limits */}
                      <div className="text-sm">
                        {(Array.isArray(item.limits_data)
                          ? item.limits_data
                          : []
                        ).map((limit, idx) => {
                          const originalLimit =
                            item.original_limits_data?.[idx]?.count;
                          return (
                            <div key={idx}>
                              {originalLimit &&
                                originalLimit !== limit.count && (
                                  <span
                                    className="text-gray-500 text-sm mr-1"
                                    style={{
                                      position: "relative",
                                      color: "#4B5563", // Tailwind's text-gray-700
                                      display: "inline-block",
                                    }}
                                  >
                                    {originalLimit}
                                    <span
                                      style={{
                                        content: '""',
                                        position: "absolute",
                                        top: "50%",
                                        left: 0,
                                        right: 0,
                                        height: "1px",
                                        backgroundColor: "red",
                                        transform: "translateY(-50%)",
                                      }}
                                    />
                                  </span>
                                )}
                              <span>
                                <span className="sm:hidden">Count : </span>
                                {limit.count}{" "}
                                <span className=" text-xs">
                                  {item.item_type === "license" &&
                                    limit.limit_name && (
                                      <>
                                        <span>{limit.limit_name}</span>
                                        {limit.count > 1 && <span>s</span>}
                                      </>
                                    )}
                                </span>
                              </span>
                            </div>
                          );
                        })}
                      </div>

                      {/* Price */}
                      <div>
                        {item.original_price &&
                          item.original_price !== item.total_price && (
                            <span
                              className=" text-sm mr-1"
                              style={{
                                position: "relative",
                                color: "#4B5563", // Tailwind's text-gray-700
                                display: "inline-block",
                              }}
                            >
                              ₹{item.original_price}
                              <span
                                style={{
                                  content: '""',
                                  position: "absolute",
                                  top: "50%",
                                  left: 0,
                                  right: 0,
                                  height: "1px",
                                  backgroundColor: "red",
                                  transform: "translateY(-50%)",
                                }}
                              />
                            </span>
                          )}
                        <span className="  text-sm">
                          <span className="sm:hidden">Price : </span>₹
                          {item.total_price}
                        </span>
                      </div>

                      {/* Remove */}
                      <div className="sm:flex justify-end hidden">
                        <img
                          src={Close_round}
                          alt="remove"
                          className="h-5 w-5 cursor-pointer"
                          onClick={() => handleDeleteCartItem(item.id)}
                        />
                      </div>
                    </div>

                    {/* Topups row (if any) */}
                    {item.topup_data.length > 0 && (
                      <div className="mt-2 grid grid-cols-1 sm:grid-cols-5 gap-4 bg-[#F4F4FF] px-4 py-3 rounded-md">
                        {/* Plan */}
                        <div className="flex justify-between">
                          {item.topup_data.map((topup) => (
                            <span
                              key={topup.id}
                              className="text-xs text-gray-500 block"
                            >
                              {topup.topup_id_name}
                            </span>
                          ))}

                          <div className="flex sm:hidden flex-col items-end gap-2">
                            {item.topup_data.map((topup) => (
                              <img
                                key={topup.id}
                                src={Close_round}
                                alt="remove add-on"
                                className="h-5 w-5 cursor-pointer"
                                onClick={() => handleDeleteTopup(topup.id)}
                              />
                            ))}
                          </div>
                        </div>

                        {/* Validity */}
                        <div className="text-sm text-gray-700">
                          {/* {item.validity} */}
                        </div>

                        {/* Limits */}
                        <div className="text-sm text-gray-700">
                          {item.topup_data.map((topup) =>
                            topup.limits_data.map((limit, idx) => (
                              <span
                                key={`${topup.id}-${idx}`}
                                className="text-xs text-gray-500 block"
                              >
                                <span className="sm:hidden">Count : </span>{" "}
                                {limit.count}
                              </span>
                            ))
                          )}
                        </div>

                        {/* Price */}
                        <div>
                          {item.topup_data.map((topup) => (
                            <span
                              key={topup.id}
                              className="text-xs text-gray-500 block"
                            >
                              <span className="sm:hidden">Price : </span> ₹
                              {topup.total_price}
                            </span>
                          ))}
                        </div>

                        {/* Remove */}
                        <div className="hidden sm:flex flex-col items-end gap-2">
                          {item.topup_data.map((topup) => (
                            <img
                              key={topup.id}
                              src={Close_round}
                              alt="remove add-on"
                              className="h-5 w-5 cursor-pointer"
                              onClick={() => handleDeleteTopup(topup.id)}
                            />
                          ))}
                        </div>
                      </div>
                    )}

                    {item.is_coupon_have && (
                      <div className="mt-2 flex flex-col sm:flex-row justify-between bg-[#F4F4FF] py-3 rounded-md px-2 items-start sm:items-center gap-3 sm:gap-4">
                        {/* Coupon Description */}
                        {item.coupon_data?.description ? (
                          <p className="text-gray-600 text-sm max-w-xs">
                            {item.coupon_data.description}
                          </p>
                        ) : (
                          <p className="text-gray-600 text-sm italic max-w-xs">
                            {/* No coupon description available. */}
                          </p>
                        )}
                        {/* coupon input box */}
                        <div className="relative w-full max-w-[200px] sm:max-w-[250px] md:max-w-[300px] lg:max-w-[350px]">
                          <input
                            type="text"
                            placeholder="Enter your coupon code."
                            value={couponInputs[item.id] || ""}
                            onChange={(e) =>
                              setCouponInputs({
                                ...couponInputs,
                                [item.id]: e.target.value,
                              })
                            }
                            className="w-full h-10 rounded border border-[#9367D7] px-3 py-1.5 pr-24 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500"
                          />
                          {loadingItem === item.id && (
                            <div className="absolute inset-0 bg-white bg-opacity-80 flex items-end justify-center rounded z-20">
                              <img
                                src={GifCoupon} // your GIF path
                                alt="Applying..."
                                className="w-24 h-24"
                              />
                            </div>
                          )}

                          {/* ✅ Loader over input */}
                          {loadingItem === item.id && (
                            <div className="absolute inset-0 bg-white bg-opacity-80 flex items-end justify-end rounded z-20">
                              <img
                                src={CoupenSuccesGif} // your GIF path
                                alt="Applying..."
                                className="w-44 h-44"
                              />
                            </div>
                          )}

                          {/* Apply button */}
                          <button
                            className={`absolute top-[4px] rounded flex items-center justify-center right-[4px] h-8 px-4 rounded-r text-sm font-bold ${
                              appliedItemIds.includes(item.id)
                                ? " text-[#9367D7] "
                                : "bg-[#9367D7] text-white  hover:opacity-90"
                            }`}
                            disabled={loadingItem === item.id}
                            onClick={() =>
                              appliedItemIds.includes(item.id)
                                ? handleRemoveCoupon(item.id)
                                : handleApplyCoupon(item)
                            }
                          >
                            {appliedItemIds.includes(item.id)
                              ? "Remove"
                              : "Apply"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}

            {calculations && (
              <div
                className="flex flex-col mb-6 mt-6 border border-[#D9D9D9] rounded-lg p-4  bg-white"
                style={{ boxShadow: "0px 1px 4px 0px #00000040" }}
              >
                <span className="text-base font-bold text-gray-900 mb-3">
                  Price Details
                </span>

                <div className="flex justify-between sm:grid grid-cols-6 text-sm text-gray-600 py-1">
                  <span>Actual Amount</span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span className="sm:px-2">₹{calculations.total_price}</span>
                </div>

                {/* <div className="flex justify-between text-sm text-gray-600 py-1">
                  <span>Discount</span>
                  <span className="text-sm text-gray-600">
                    ₹-{calculations.total_offer}
                  </span>
                </div> */}

                <div className="flex justify-between sm:grid grid-cols-6 text-sm text-gray-600 py-1">
                  <span>
                    Tax Amount {""}({calculations.tax_percentage}%)
                  </span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span className="text-sm text-gray-600 sm:px-2">
                    ₹{calculations.percentage_value}
                  </span>
                </div>

                {/* {calculations?.tds_percentage > 0 && (
                  <div className="flex items-center text-sm text-gray-600 py-1">
                    <input
                      type="checkbox"
                      id="tds"
                      className="mr-2"
                      checked={tdsDeducted}
                      onChange={handleTdsToggle}
                    />
                    <label
                      htmlFor="tds"
                      className="cursor-pointer text-sm text-gray-600"
                    >
                      Apply TDS Deduction
                    </label>
                  </div>
                )} */}

                {/* ✅ TDS Amount (conditionally shown) */}
                {tdsDeducted && calculations?.tds_percentage > 0 && (
                  <div className="flex justify-between text-sm text-gray-600 py-1">
                    <span>TDS Deducted</span>
                    <span className="text-sm text-green-600">
                      ₹-{Math.round(tdsAmount)}
                    </span>
                  </div>
                )}

                <div className="flex justify-between sm:grid grid-cols-6 items-center border-t border-gray-100 mt-3 pt-3">
                  <span className="text-base font-bold text-gray-900 ">
                    Total Amount
                  </span>
                  <span></span>
                  <span></span>
                  <span></span>
                  <span className="text-base font-bold text-gray-900 sm:px-2">
                    ₹
                    {Math.round(
                      tdsDeducted
                        ? calculations.grant_total - tdsAmount
                        : calculations.grant_total
                    )}
                  </span>
                  <div className="flex items-center gap-4 justify-end">
                    <span
                      className="text-sm font-semibold cursor-pointer h-8 flex items-center px-4 py-2 rounded text-white"
                      style={{
                        background:
                          "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                      }}
                      onClick={toggleModal}
                    >
                      Check Out
                    </span>
                  </div>
                </div>
              </div>
            )}

            {/* ...rest of your price calculations and checkout code */}
          </>
        ) : (
          <div className=" mt-6">
            {" "}
            <span className="">Your cart is empty.</span>
          </div>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white w-3/4 md:w-1/2 p-6 rounded-lg">
            <h1 className="mt-4 text-black text-inter text-2xl font-semibold">
              Billing Address
            </h1>

            <div className="w-full  bg-white rounded-lg border border-[#D9D9D9] flex flex-col mt-4">
              {/* Top Half */}
              <div className="w-full py-5 h-1/2 bg-[#F7F2FF] border-b border-gray-300 flex items-center justify-between px-4 rounded-tl-lg rounded-tr-lg">
                <h2 className="text-xl font-inter font-semibold text-gray-800">
                  Default Address
                </h2>
                <button
                  className="text-white text-sm font-medium px-4 py-2 rounded-md"
                  style={{
                    background:
                      "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                  }}
                  onClick={toggleAddressModal}
                >
                  Add New Address
                </button>
              </div>

              {/* Bottom Half */}
              <div className="w-full h-1/2 flex py-5 flex-col justify-center px-4">
                {defaultAddress ? (
                  <h2 className="text-base font-semibold text-black text-inter">
                    {defaultAddress.address_1}, {defaultAddress.city},{" "}
                    {defaultAddress.pincode}, {defaultAddress.district},{" "}
                    {defaultAddress.state}, {defaultAddress.country}
                  </h2>
                ) : (
                  <p className="text-sm text-gray-500">
                    No default address available.
                  </p>
                )}
              </div>
            </div>

            {/* Address List */}
            <div className="overflow-x-auto mt-6">
              <div className="flex space-x-4">
                {addresses.length > 0 ? (
                  // Sort the addresses so the default address comes first
                  addresses
                    .sort(
                      (a, b) => (b.is_default ? 1 : 0) - (a.is_default ? 1 : 0)
                    ) // Sort addresses with default first
                    .map((address, index) => (
                      <div
                        key={index}
                        className="flex-shrink-0 w-[400px] h-[158px] bg-white border border-[#D9D9D9] rounded-md px-2 flex"
                      >
                        {/* Address Content (on the left side, 90% width) */}
                        <div className="flex-1">
                          <h2 className="text-base font-semibold text-black text-inter px-2 py-2">
                            {address.address_1}, {address.city}, {""}
                            {address.pincode}, {address.district},{" "}
                            {address.state}, {address.country}
                          </h2>
                        </div>

                        <div className="w-[10%] flex flex-col items-center justify-between gap-2 px-2 py-2">
                          {/* Custom Checkbox */}
                          <div className="relative">
                            <input
                              type="checkbox"
                              checked={address.is_default}
                              onChange={() =>
                                handleSetDefaultAddress(address.id)
                              } // Trigger onChange to set default
                              className="w-5 h-5 cursor-pointer"
                              style={{
                                appearance: "none",
                                borderRadius: "4px",
                                border: "2px solid #9061DB",
                                backgroundColor: address.is_default
                                  ? "#9061DB"
                                  : "transparent", // Conditional background
                              }}
                            />

                            {/* Checkmark (tick) with inline styles */}
                            {address.is_default && (
                              <div
                                style={{
                                  color: "white",
                                  fontSize: "16px",
                                  fontWeight: "bold", // Added bold for better visibility
                                  position: "absolute",
                                  bottom: "4px",
                                  right: "3px", // Position the checkmark inside the checkbox
                                }}
                              >
                                ✓
                              </div>
                            )}
                          </div>

                          {/* Update Icon */}
                          <img
                            src={editIcon} // Replace with the actual path to your image
                            alt="Update"
                            className="w-5 h-5 cursor-pointer" // Fixed size for consistency
                            onClick={() => handleUpdate(index)} // Call your update function here
                          />

                          {/* Delete Icon */}
                          <img
                            src={deleteIcon} // Replace with the actual path to your image
                            alt="Delete"
                            className="w-5 h-5 cursor-pointer" // Fixed size for consistency
                            onClick={() => toggleDeleteModal(address.id)} // Open Delete Modal with selected address ID
                          />
                        </div>
                      </div>
                    ))
                ) : (
                  <p className="text-sm text-gray-500 px-4">
                    No addresses available.
                  </p>
                )}
              </div>
            </div>

            {/* Button Container for Cancel and Proceed */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                className="text-white text-sm font-medium px-4 py-2 rounded-md disabled:opacity-50 disabled:cursor-not-allowed"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={() => {
                  if (defaultAddress) {
                    handleProceed();
                  } else {
                    alert(
                      "Please select a default billing address before proceeding."
                    );
                  }
                }}
                disabled={!defaultAddress || isLoading}
              >
                {isLoading ? "Processing..." : "Proceed"}
              </button>
              {/* Cancel Button */}
              <button
                className="text-sm font-semibold px-4 py-2 rounded-md border border-[#9367D7] text-[#9367D7]"
                onClick={toggleModal} // You can handle the cancel functionality here
              >
                Cancel
              </button>

              {/* Proceed Button */}
              {/* <button
                className="text-white text-sm font-medium px-4 py-2 rounded-md"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleProceed}
              >
                Proceed
              </button> */}
            </div>
          </div>
        </div>
      )}
      {/* Add Modal */}
      {isAddressModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <div class="flex justify-between mb-4">
              <h2 className="text-2xl font-bold text-left">Billing Address</h2>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={toggleAddressModal}
              />
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto max-h-[60vh] pr-1">
              <div className="flex flex-col mb-4 text-sm">
                <label htmlFor="address">
                  Street <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="address"
                  maxLength={150}
                  placeholder="Street"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={address}
                  // onChange={(e) => setAddress(e.target.value)}
                  onChange={(e) => {
                    setAddress(e.target.value);
                    if (e.target.value.trim()) {
                      setErrors((prev) => ({ ...prev, address: "" }));
                    }
                  }}
                />
                {errors.address && (
                  <p className="text-red-600 text-xs mt-0">{errors.address}</p>
                )}

                <label htmlFor="postalCode">
                  Postal Code<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="postalCode"
                  maxLength={10}
                  placeholder="Postal Code"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={postalCode}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, ""); // remove all non-digit characters
                    setPostalCode(numericValue);

                    if (numericValue.length === 6) {
                      handlePostalCodeChange({
                        target: { value: numericValue },
                      });
                    }

                    if (numericValue.trim()) {
                      setErrors((prev) => ({ ...prev, postalCode: "" }));
                    }
                  }}
                />

                {errors.postalCode && (
                  <p className="text-red-600 text-xs mt-0">
                    {errors.postalCode}
                  </p>
                )}

                <label htmlFor="city">
                  City<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="city"
                  maxLength={100}
                  placeholder="City"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={city}
                  onChange={(e) => {
                    setCity(e.target.value);
                    if (e.target.value.trim()) {
                      setErrors((prev) => ({ ...prev, city: "" }));
                    }
                  }}
                />
                {errors.city && (
                  <p className="text-red-600 text-xs mt-0">{errors.city}</p>
                )}

                <label htmlFor="district">
                  District<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="district"
                  maxLength={50}
                  placeholder="District"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={district}
                  onChange={(e) => {
                    setDistrict(e.target.value);
                    if (e.target.value.trim()) {
                      setErrors((prev) => ({ ...prev, district: "" }));
                    }
                  }}
                />
                {errors.district && (
                  <p className="text-red-600 text-xs mt-0">{errors.district}</p>
                )}

                <label htmlFor="state">
                  State<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  maxLength={50}
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={state}
                  onChange={(e) => {
                    setState(e.target.value);
                    if (e.target.value.trim()) {
                      setErrors((prev) => ({ ...prev, state: "" }));
                    }
                  }}
                />
                {errors.state && (
                  <p className="text-red-600 text-xs mt-0">{errors.state}</p>
                )}

                <label htmlFor="country">
                  Country<span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  id="country"
                  maxLength={50}
                  placeholder="Country"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={country}
                  onChange={(e) => {
                    setCountry(e.target.value);
                    if (e.target.value.trim()) {
                      setErrors((prev) => ({ ...prev, country: "" }));
                    }
                  }}
                />
                {errors.country && (
                  <p className="text-red-600 text-xs mt-0">{errors.country}</p>
                )}

                <label htmlFor="gstNo">GST No (optional)</label>
                <input
                  type="text"
                  id="gstNo"
                  placeholder="GST Number"
                  maxLength={20}
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={gstNo}
                  onChange={(e) => setGstNo(e.target.value)}
                />
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-4 mt-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleSaveAddress}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit Modal */}
      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/5 max-w-lg overflow-hidden">
            <div class="flex justify-between mb-4">
              <span className="text-xl font-bold text-left ">
                Edit Billing Address
              </span>
              <img
                src={Close_roundClose}
                alt=""
                className="cursor-pointer"
                onClick={toggleEditModal}
              />
            </div>

            <div className="overflow-y-auto max-h-96">
              <div className="flex flex-col mb-4 text-xs">
                {/* Address Form */}
                <label htmlFor="address">Address</label>
                <input
                  type="text"
                  id="address"
                  placeholder="Street Address"
                  className="mb-2 p-2 rounded-lg border border-[#9061DB]"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />

                <label htmlFor="postalCode">Postal Code</label>
                <input
                  type="text"
                  id="postalCode"
                  placeholder="Postal Code"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB]"
                  value={postalCode}
                  // onChange={(e) => setPostalCode(e.target.value)}
                  onChange={(e) => {
                    const numericValue = e.target.value.replace(/\D/g, ""); // remove all non-digit characters
                    setPostalCode(numericValue);

                    if (numericValue.length === 6) {
                      handlePostalCodeChange({
                        target: { value: numericValue },
                      });
                    }

                    if (numericValue.trim()) {
                      setErrors((prev) => ({ ...prev, postalCode: "" }));
                    }
                  }}
                />

                <label htmlFor="city">City</label>
                <input
                  type="text"
                  id="city"
                  placeholder="City"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={city} // Fill city dynamically
                  onChange={(e) => setCity(e.target.value)} // Update city
                />

                <label htmlFor="district">District</label>
                <input
                  type="text"
                  id="district"
                  placeholder="District"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={district} // Fill district dynamically
                  onChange={(e) => setDistrict(e.target.value)} // Update district
                />

                <label htmlFor="state">State</label>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={state} // Fill state dynamically
                  onChange={(e) => setState(e.target.value)} // Update state
                />

                <label htmlFor="country">Country</label>
                <input
                  type="text"
                  id="country"
                  placeholder="Country"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={country} // Fill country dynamically
                  onChange={(e) => setCountry(e.target.value)} // Update country
                />

                <label htmlFor="gstNo">GST No (optional)</label>
                <input
                  type="text"
                  id="gstNo"
                  placeholder="GST Number"
                  className="mb-2 p-2 border rounded-lg border-[#9061DB] rounded"
                  value={gstNo} // Fill GST number dynamically
                  onChange={(e) => setGstNo(e.target.value)} // Update GST number
                />

                {/* Other fields like City, District, State, Country, GST */}
                {/* Repeat for other fields... */}
              </div>
            </div>
            <div className="flex justify-end mt-4">
              <button
                className="text-sm font-medium py-2 text-white py-2 rounded-md px-3"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleEditAddress}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto">
            <h2 className="text-xl font-bold text-center mb-4">
              Confirm Deletion
            </h2>
            <p className="text-lg text-center mb-4">
              Do you want to delete this address?
            </p>
            <div className="flex justify-end gap-4">
              <button
                className="text-sm font-medium px-6 py-2 rounded-md text-white w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={handleDeleteAccount} // Confirm deletion
              >
                Delete
              </button>
              <button
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
                onClick={toggleDeleteModal} // Close the modal
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Single Modal for Success and Error Messages */}
      {isMessageModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`bg-white p-6 rounded-lg shadow-lg w-2/5 ${
              messageType === "success" ? "border-green-500" : "border-red-500"
            }`}
          >
            {/* <h2 className="text-xl font-bold text-center mb-4">
              {messageType === "success" ? "Success" : "Error"}
            </h2> */}
            <p className="text-lg text-center mb-4">{message}</p>
            <div className="flex justify-center">
              <button
                className="text-sm text-white text-inter font-bold px-6 py-2 rounded-md w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
                onClick={toggleMessageModal} // Close the modal
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Postal Location Modal */}
      {showPostalModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] overflow-hidden">
            <h2 className="text-xl font-bold font-inter text-left mb-4">
              Select Postal Location
            </h2>

            {/* Postal Location List */}
            <div className="space-y-4 overflow-y-auto max-h-[60vh] pr-1">
              {locations.length > 0 ? (
                locations.map((location) => (
                  <div key={location.id} className="flex items-center">
                    <input
                      type="radio"
                      name="postalLocation"
                      value={location.id}
                      checked={selectedLocation?.id === location.id}
                      onChange={() => handleLocationSelection(location)}
                      className="mr-2"
                    />
                    <label className="text-sm">{location.postalLocation}</label>
                  </div>
                ))
              ) : (
                <p className="text-sm text-gray-500">
                  No Postal Locations available.
                </p>
              )}
            </div>

            {/* Buttons */}
            <div className="flex flex-col sm:flex-row justify-end gap-4 mt-6">
              <button
                onClick={handleConfirmLocation}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24 text-white"
                style={{
                  background:
                    "linear-gradient(270deg, #9061DB 0%, #8777F3 100%)",
                }}
              >
                Confirm
              </button>
              <button
                onClick={handleModalClose}
                className="text-sm font-medium px-6 py-2 rounded-md w-full sm:w-24"
                style={{
                  background:
                    "linear-gradient(270deg, #E6E2FF 0%, #D4C6FF 100%)",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {domainModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md text-center relative">
            {/* Cross Button */}
            <button
              onClick={() => setDomainModalOpen(false)}
              className="absolute top-2 right-3 text-gray-500 hover:text-gray-700 text-2xl font-bold focus:outline-none"
            >
              &times;
            </button>

            <h2 className="text-xl text-inter font-bold text-black-600 mb-4">
              Domain Already Exists. Please choose another one.
            </h2>

            <div className="space-y-4 text-left">
              {/* Company Name */}
              <div>
                <label className="block text-sm mb-1 font-normal font-inter">
                  Company name
                </label>
                <div className="relative">
                  <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-black">
                    <img
                      src={CompanyIcon}
                      className="h-5 w-5"
                      alt="Company Icon"
                    />
                  </span>
                  <input
                    type="text"
                    className="w-full pl-10 pr-4 py-2 border-2 border-[#9061DB] bg-transparent rounded-md font-inter focus:outline-none focus:ring-2 focus:ring-[#9061DB]"
                    placeholder="Company name"
                    value={duplicateDomainInfo.organization_name}
                    readOnly
                  />
                </div>
              </div>

              {/* Domain */}
              <div>
                <label className="block text-sm mb-1 font-normal font-inter">
                  Domain
                </label>
                <div className="relative w-full flex">
                  <input
                    type="text"
                    className="w-1/2 pl-4 pr-4 py-2 border-2 border-[#9061DB] bg-transparent rounded-md font-inter focus:outline-none focus:ring-2 focus:ring-[#9061DB]"
                    placeholder="Subdomain"
                    value={editedDomain}
                    onChange={(e) =>
                      setEditedDomain(
                        e.target.value.replace(/[^a-z0-9]/gi, "").toLowerCase()
                      )
                    }
                  />
                  <div className="w-1/2 flex items-center justify-center bg-gray-200 text-gray-600 rounded-r-md py-2 px-4">
                    .onzitr.com
                  </div>
                </div>
              </div>
            </div>

            <button
              onClick={handleDomainEditAndProceed}
              className="mt-6 bg-[#9061DB] text-white px-4 py-2 rounded hover:opacity-90"
            >
              Continue
            </button>
          </div>
        </div>
      )}

      {genericErrorModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 px-1">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md text-center">
            {/* <h2 className="text-xl font-bold text-red-600 mb-3">Error</h2> */}
            <p className=" font-medium  text-inter mb-2 ">
              {/* This application has already been purchased. */}
              {genericErrorMessage}
            </p>

            {/* <ul className="text-left text-sm list-inside list-disc">
              <li>Choose a Top-Up Plan if you need additional users.</li>
              <li>Upgrade if you need a higher plan.</li>
              <li>Renew if the expiry date has passed.</li>
            </ul> */}
            <div className="w-full flex justify-end">
              <button
                className="mt-4 bg-[#9061DB] text-white px-4 py-2 justify-center rounded hover:opacity-90"
                onClick={() => setGenericErrorModalOpen(false)}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}
      {errorModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-sm mx-auto text-center">
            {/* <h2 className="text-xl font-bold text-red-600 mb-3">Error</h2> */}
            <p className=" font-inter text-base">{errorModalMessage}</p>
            <button
              onClick={() => setErrorModalOpen(false)}
              className="mt-4 bg-[#9061DB] text-white px-6 py-2 rounded hover:opacity-90 w-full sm:w-auto"
            >
              OK
            </button>
          </div>
        </div>
      )}

      {paymentSuccessModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
          <div className="relative bg-white p-6 rounded-lg shadow-lg w-full max-w-md mx-auto text-center sm:max-w-lg md:max-w-xl sm:px-8 md:px-12">
            {/* Close Icon Button */}
            <button
              className="absolute top-3 right-3 text-gray-500 hover:text-gray-800 text-xl font-bold"
              onClick={() => {
                setPaymentSuccessModalOpen(false);
                if (isPaymentVerified) {
                  navigate("/MyProducts");
                }
              }}
              aria-label="Close"
            >
              &times; {/* This renders as a clean "×" close icon */}
            </button>

            <h1 className="text-2xl font-bold text-green-600 sm:text-3xl mb-5">
              Payment Successful
            </h1>

            <p className="mb-6 text-sm px-2 sm:px-0 text-left">
              Thank you for your payment! Your transaction was successful. Check
              your email for credentials and details, or click continue to
              login.
            </p>

            <div className="w-full flex justify-center">
              <button
                className="bg-purple-600 text-white px-6 py-2 rounded hover:bg-purple-700 w-full sm:w-auto sm:px-10"
                onClick={() => {
                  window.open(
                    `https://${paymentDomain}`,
                    "_blank",
                    "noopener,noreferrer"
                  );
                  navigate("/MyProducts");
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {isVerifyingPayment && (
        <div className="fixed inset-0 z-[100] bg-white bg-opacity-60 backdrop-blur-sm flex flex-col items-center justify-center px-4 text-center">
          <div className="w-16 h-16 border-4 border-[#9061DB] border-t-transparent rounded-full animate-spin"></div>
          <p className="mt-4 text-sm text-[#9061DB] font-medium max-w-xs">
            Verifying payment, please wait...
          </p>
        </div>
      )}
    </div>
  );
};

export default Cart;
